<template>
    <v-container fluid>
        <new-supplier-form @create="create"></new-supplier-form>
    </v-container>
</template>
<script>
import NewSupplierForm from './NewSupplierForm.vue';
export default {
    name: 'NewSupplier',
    props: {},
    components: {
        NewSupplierForm
    },
    data() {
        return {};
    },
    methods: {
        create(val) {
            this.$router.push({ name: 'ViewSupplier', params: { supplierId: val } });
        }
    },

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped></style>